import { createSlice } from "@reduxjs/toolkit";
import { fetchArchiveServicesCWSNEnrolmentData,updateMergeDataToActualData } from "../thunks/archiveServicesThunk";

const archiveServicesEnrolmentSlice = createSlice({
  name: "archiveServicesEnrolment",
  initialState: {
    data: [{
            "regionType": "",
            "regionCode": "",
            "yearId": "11",
            "location": "India",
            "rural_urban": "Urban",
            "school_management": "School mgt.",
            "school_type": "School Type.",
    }],
    isLoading:true,
    isError:false,
    error:null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchiveServicesCWSNEnrolmentData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchArchiveServicesCWSNEnrolmentData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchiveServicesCWSNEnrolmentData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(updateMergeDataToActualData.fulfilled, (state, action) => {
        state.data.data = action.payload;
        state.isLoading = false;
      })
  },
});

export default archiveServicesEnrolmentSlice.reducer;